__turbopack_context__.v({
  "ComparePage": "DdDaDa_ComparePage",
  "ComparePage__Col": "DdDaDa_ComparePage__Col",
  "ComparePage__Container": "DdDaDa_ComparePage__Container",
  "ComparePage__Field": "DdDaDa_ComparePage__Field",
  "ComparePage__Field--Header": "DdDaDa_ComparePage__Field--Header",
  "ComparePage__FieldText": "DdDaDa_ComparePage__FieldText",
  "ComparePage__Footer": "DdDaDa_ComparePage__Footer",
  "ComparePage__Grid": "DdDaDa_ComparePage__Grid",
  "ComparePage__Header": "DdDaDa_ComparePage__Header",
  "ComparePage__Hero": "DdDaDa_ComparePage__Hero",
  "ComparePage__Overlay": "DdDaDa_ComparePage__Overlay",
  "ComparePage__ProductHeader": "DdDaDa_ComparePage__ProductHeader",
  "ComparePage__Row": "DdDaDa_ComparePage__Row",
  "ComparePage__Wrapper": "DdDaDa_ComparePage__Wrapper",
});
